import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { get } from 'lodash';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { Store } from './types';
import { CLOUDINARY_BASE_URL } from './Constants';

const Language: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedLanguage, setSelectedLanguage] = React.useState(null);
    const storeConfiguration = useSelector(({ app }: Store) => app.storeConfiguration);
    const availableLanguages = useSelector(({ app }: Store) => app.availableLanguages);
    const open = Boolean(anchorEl);

    React.useEffect(() => {
        if (!storeConfiguration || !availableLanguages) {
            return;
        }

        const { defaultUILanguageID, selectedLanguages } = storeConfiguration;
        const selectedLang = selectedLanguages.find(
            ({ languageID, isSelectedUI }) =>
                isSelectedUI && languageID === defaultUILanguageID
        );
        const lang = availableLanguages.find(
            ({ id }) => id === get(selectedLang, ['languageID'])
        );

        setSelectedLanguage(get(lang, ['code'], null));
    }, [storeConfiguration, availableLanguages]);

    const handleClick = React.useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        },
        [setAnchorEl]
    );

    const handleMenuClose = React.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);

    const handleMenuItemClose = React.useCallback(
        (languageCode: string) => () => {
            if (languageCode !== selectedLanguage) {
                i18next.changeLanguage(languageCode);
                setSelectedLanguage(languageCode);
            }
            setAnchorEl(null);
        },
        [selectedLanguage, setAnchorEl]
    );

    if (!storeConfiguration || !selectedLanguage || !availableLanguages) {
        return null;
    }

    const { selectedLanguages } = storeConfiguration;

    return (
        <>
            <div
                id='menu-dropdown-languages'
                aria-controls='menu-languages'
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                className='menu-icon'
                onClick={handleClick}>
                <img
                    className='flag'
                    src={`${CLOUDINARY_BASE_URL}/generic/languages/${selectedLanguage}.png`}
                />
            </div>
            <Menu
                id='menu-languages'
                anchorEl={anchorEl}
                open={open}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                onClose={handleMenuClose}
                MenuListProps={{ 'aria-labelledby': 'menu-dropdown-languages' }}>
                {selectedLanguages
                    .filter(({ isSelectedUI }) => isSelectedUI)
                    .map(({ languageID }) => {
                        const { code, name } = availableLanguages.find(
                            ({ id }) => id === languageID
                        );

                        return (
                            <MenuItem
                                key={languageID}
                                className='menu-item'
                                onClick={handleMenuItemClose(code)}>
                                <img
                                    className='flag'
                                    src={`${CLOUDINARY_BASE_URL}/generic/languages/${code}.png`}
                                />
                                {name}
                            </MenuItem>
                        );
                    })}
            </Menu>
        </>
    );
};

export default Language;
